<template>
  <!-- 社教活动管理 -->
  <div class="page-activity-manage">
    <!-- 列表头部 -->
    <div class="com-list-header" style="padding-right: 0;padding-bottom:60px">
      <div class="nav-list">
        <div class="nav-item" :class="{ 'active': activeIndex === item.id }" v-for="item in typeList" :key="item.id"
          @click="handleClickNav(item)">{{ item.name }}({{ item.count }})</div>
      </div>

      <el-form @keyup.enter.native="getTableList" class="com-search-box" ref="form" :model="form" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="5">
            <el-form-item label="关键字 :" prop="key" placeholder="请输入">
              <el-input v-model="form.key"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="5">
            <el-form-item label="类型 :" prop="type">
              <el-select v-model="form.type" @change="handleTypeChange" placeholder="请选择">
                <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="5">
            <el-form-item label="状态 :" prop="status">
              <el-select v-model="form.status" placeholder="请选择">
                <el-option v-for="item in statusList" :key="item.dictCode" :label="item.dictName"
                  :value="item.dictCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <el-form-item label="活动时间 :" prop="startTime">
              <el-date-picker style="width: 220px;" v-model="form.startTime" format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm" type="datetime" placeholder="选择日期时间"></el-date-picker>
              <span class="ml-10 mr-10">-</span>
              <el-date-picker style="width: 220px;" v-model="form.endTime" format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm" type="datetime" placeholder="选择日期时间"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="com-head-search-btns" style="bottom: 10px;top: auto">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="restList">重置</el-button>
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="button">
        <el-row>
          <el-button class="el-primary-border" @click="handleAdd('add')">
            <svg-icon icon-class="add" />&nbsp;新建
          </el-button>

          <!-- <el-button v-if="activeIndex == 3" @click="exportList" :class="{'el-primary-border':chooseRowIds}" :disabled="!chooseRowIds">
            <svg-icon icon-class="add" />&nbsp;导出
          </el-button> -->
          <!-- <cmpMyExport
            class="ml-20"
            @clearSelectsCall="clearSelectsCall"
            :chooseIds="chooseRowIds"
            :chooseApi="`/scheme/exportScheme?arr=`"
            :searchApi="`/scheme/exportSchemeAll?schemeName=`+form.schemeName+`&schemeNumber=`+form.schemeNumber+`&planYear=`+form.planYear+`&dataState=`+form.dataState"
          ></cmpMyExport>-->
        </el-row>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData"
          @selection-change="handleSelectionChange">
          <!-- <el-table-column v-if="activeIndex == 3" type="selection" width="55">
          </el-table-column> -->
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column prop="activityName" label="活动名称" min-width="10%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="typeName" label="活动类型" min-width="8%"></el-table-column>
          <el-table-column prop="typeName" label="二级分类" min-width="7%">
            <template slot-scope="scope">
              <span>{{ scope.row.twoLevelType | filterTwoLevel(that) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="activityStatusName" label="活动状态" min-width="8%"></el-table-column>
          <el-table-column prop="activityAddr" label="活动地点" min-width="10%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="activityTime" label="活动时间" min-width="13%">
            <template slot-scope="scope">
              <span v-if="scope.row.type == 3">{{ scope.row.activityTime }} - {{ scope.row.activityTimeEnd }}</span>
              <span v-else>{{ scope.row.activityTime }}</span>

            </template>
          </el-table-column>
          <el-table-column prop="repeatSetName" label="报名限制" min-width="8%"></el-table-column>
          <el-table-column prop="quota" label="名额" min-width="7%"></el-table-column>
          <el-table-column prop="signCount" label="已报名" min-width="7%"></el-table-column>
          <el-table-column prop="assessCount" label="评论" min-width="7%"></el-table-column>
          <!-- <el-table-column prop="schemeNumber" label="状态" min-width="6%">
            <template slot-scope="scope">
              <span>已注册</span>
            </template>
          </el-table-column>-->

          <!-- 操作 -->
          <el-table-column fixed="right" label="操作" min-width="18%">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="handleAdd('detail', scope.row.id)">查看</a>
              <a class="m-btn mr-10" @click="handleAdd('edit', scope.row.id)">编辑</a>
              <a class="m-btn mr-10" @click="handleShowInfo(scope.row.id)">资料</a>
              <a class="m-btn mr-10" @click="handleShare(scope.row.id)" v-if="scope.row.activityStatus !== '2'">分享</a>
              <a class="m-btn mr-10 m-danger" @click="handleDelete(scope.row.id)">删除</a>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background
            layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <dialogAddActivity ref="dialogAddActivity" @refresh="restList"></dialogAddActivity>
    <dialogActivityInfo ref="dialogActivityInfo" @refresh="restList"></dialogActivityInfo>
    <dialogQrcode ref="dialogQrcode" @refresh="restList"></dialogQrcode>
  </div>
</template>

<script>
import cmpMyExport from '@cmp/my-export'
import dialogAddActivity from './dialog-add-activity'
import dialogActivityInfo from './../dialog-activity-info'
import dialogQrcode from '@views/collect2/out-storage/dialog-qrcode'
export default {
  components: {
    cmpMyExport,
    dialogAddActivity,
    dialogActivityInfo,
    dialogQrcode
  },
  data() {
    return {
      that: this,
      form: {
        key: '',
        type: '', //	活动类型
        status: '' //	活动状态
      },
      serviceList: [{ id: '1', name: '赴农村' }, { id: '2', name: '进校园' }, { id: '3', name: '进企业' }, { id: '4', name: '进军营' }, { id: '5', name: '进计关' }, { id: '6', name: '进社区' }, { id: '7', name: '其他' }],
      typeList: [],
      statusList: [],
      listLoading: true,
      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0,
      activeIndex: null,
      tableData: [],
      chooseRowIds: '' // 当前导出选中藏品id
    }
  },
  filters: {
    filterTwoLevel(levelTye, context) {
      let arr = context.serviceList.filter(item => {
        return item.id == levelTye
      })

      if (arr && arr.length > 0) {
        return arr[0].name
      }

      return null
    },
  },
  methods: {
    // 初始化表格
    initList(type) {
      this.listLoading = true
      this.$http
        .get('/bsActivity/getActivityList', {
          ...this.listQuery,
          ...this.form
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            if (
              type === 'dele' &&
              this.listQuery.currentPage > 1 &&
              !res.result.length
            ) {
              this.listQuery.currentPage -= 1
              this.initList()
              return
            }
            this.tableData = res.result
            this.total = res.page.allRow
          } else {
            this.$message.error(res.message)
          }
        })
    },

    //活动类型改变
    handleTypeChange(item) {
      console.log(item)
      this.activeIndex = item
    },

    // 获取下拉状态多选择值
    getDropdownValue() {
      this.$http.post('/collectDict/getSelectDataByArr', {
        arr: ['activity_status']
      }).then(res => {
        if (res.success) {
          var state = res.result, total = 0
          let firstArr = [{ dictCode: null, dictName: '全部', count: 0 }]
          // this.typeList = firstArr.concat(state['activity_type'])
          this.statusList = firstArr.concat(state['activity_status'])
          // this.typeList.map((item, index) => {
          //   if (index != 0) {
          //     let count = Math.ceil(Math.random() * 100)
          //     item.count = count
          //     total += parseInt(count)
          //   }
          // })
          // this.typeList[0].count = total
        } else {
          this.$message.error(res.message)
        }
      })
    },

    getActivityCount() {
      this.$http.get('/bsActivity/countActivityByType').then(res => {
        if (res.success) {
          let total = 0
          res.result.map(item => {
            total += item.count
          })
          this.typeList = res.result
          this.typeList.unshift({ id: null, name: "全部", count: total })
        }
      })
    },

    handleClickNav(item) {
      this.activeIndex = item.id
      this.form.type = item.id
      this.getTableList()
    },

    // 重置查询
    restList() {
      this.$refs['form'].resetFields()
      this.form.endTime = ""
      this.listQuery.currentPage = 1
      this.initList()

      this.getActivityCount()
    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.initList()
    },

    // 删除
    handleDelete(id) {
      this.$common.confirm(
        {
          title: '您正在删除活动，是否确认删除？',
          className: 'cus-confirm-375'
        },
        () => {
          this.$http
            .delete('/bsActivity/deleteActivity', {
              id: id
            })
            .then(res => {
              if (res.success) {
                this.$message.success('活动删除成功')
                this.initList('dele')
              } else {
                this.$message.error(res.message)
              }
            })
        }
      )
    },

    // 新增
    handleAdd(type, id) {
      if (type === 'detail') {
        this.$router.push({
          path: '/activity/activity-manage/detail',
          query: {
            id: id
          }
        })
      } else {
        this.$refs.dialogAddActivity.init(type, id)
      }
    },

    // 导出
    exportList() {
      if (!this.chooseRowIds) {
        this.$message.warning('请选择要导出的小讲解员')
        return
      }

      location.href =
        '/singleMuseum/bsActivity/exportData?ids=' + this.chooseRowIds
      // this.$api.volunteer.exportAdultList({ids:this.chooseRowIds}).then(res=>{
      //   console.log(res)
      // })
    },
    // 资料管理
    handleShowInfo(id) {
      this.$refs.dialogActivityInfo.init(id)
    },

    handleShare(id) {
      this.$refs.dialogQrcode.init(id, '2')
    },

    handleSelectionChange(list) {
      let arr = []
      list.forEach(item => {
        arr.push(item.id)
      })
      this.chooseRowIds = arr.join(',')
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.initList()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.initList()
    },
    // 清空选中状态
    clearSelectsCall() {
      this.$refs.multipleTable.clearSelection()
    }
  },
  created() {
    this.initList()
    this.getActivityCount()
    this.getDropdownValue()
  }
}
</script>

<style lang="scss" scoped>
.page-activity-manage {
  .nav-list {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;

    .nav-item {
      margin-bottom: 10px;
      padding: 5px 10px;
      color: $color6;
      font-size: 14px;
      border: solid 1px $border;
      border-radius: 4px;
      margin-right: 20px;
      cursor: pointer;

      &.active {
        background-color: $primary;
        color: #fff;
        border-color: $primary;
      }
    }
  }
}
</style>